module.exports = __webpack_public_path__ + "static/media/tint-slash.515b746d.svg";